// TODO: setup env

import { localStoragePlugin } from './persistence/localStorage';

// Export default process.env.NODE_ENV !== 'production' ? [localStoragePlugin] : [localStoragePlugin]
export default [localStoragePlugin];
